// True when the user's assigned modules grant `path` (or a parent of it).
// Same check ModuleRouteGuard runs on every route, so a link hidden by this
// helper is exactly a link that would otherwise land on Not Found.
export const canAccessPath = (allowedPaths = [], path = "") =>
  allowedPaths.some((allowed) => path.startsWith(allowed));
